import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { articlesMock } from '@/mocks/home';

const categories = ['全部', '游戏攻略', '新手教程', '平台动态', '玩家故事', '行业资讯'];

export default function Articles() {
  const [activeCategory, setActiveCategory] = useState('全部');

  const filteredArticles =
    activeCategory === '全部'
      ? articlesMock
      : articlesMock.filter((a) => a.category === activeCategory);

  useEffect(() => {
    document.title = '游戏资讯 - 开云棋牌 | 棋牌游戏攻略、技巧与行业动态';
  }, []);

  return (
    <>
      <Navbar />
      <main className="pt-16 md:pt-18">
        <nav className="bg-background-50 border-b border-background-200" aria-label="面包屑导航">
          <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
            <ol className="flex items-center gap-1.5 py-3 text-xs md:text-sm flex-wrap">
              <li>
                <Link to="/" className="text-foreground-400 hover:text-primary-500 transition-colors">
                  首页
                </Link>
              </li>
              <li className="text-foreground-300">
                <i className="ri-arrow-right-s-line text-xs"></i>
              </li>
              <li className="text-foreground-700 font-medium">游戏资讯</li>
            </ol>
          </div>
        </nav>

        <section className="py-10 md:py-16 bg-background-50">
          <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
            <div className="text-center mb-10 md:mb-14">
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-50 mb-4">
                <i className="ri-article-line text-primary-500 text-sm"></i>
                <span className="text-primary-600 text-xs font-medium">资讯中心</span>
              </div>
              <h1 className="text-2xl md:text-4xl font-bold text-foreground-900 font-heading mb-3">
                游戏<span className="text-primary-600">资讯</span>
              </h1>
              <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
                棋牌游戏攻略、技巧分享与行业最新动态
              </p>
            </div>

            <div className="flex flex-wrap items-center justify-center gap-2 mb-8 md:mb-12">
              {categories.map((cat) => (
                <button
                  key={cat}
                  onClick={() => setActiveCategory(cat)}
                  className={`px-5 py-2.5 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                    activeCategory === cat
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                  }`}
                >
                  {cat}
                </button>
              ))}
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
              {filteredArticles.map((article) => (
                <Link
                  key={article.id}
                  to={`/articles/${article.id}`}
                  className="group bg-background-50 rounded-xl border border-background-200 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
                >
                  <div className="relative h-48 overflow-hidden">
                    <img
                      src={article.image}
                      alt={article.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                    <div className="absolute top-3 left-3">
                      <span className="px-2.5 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-medium">
                        {article.category}
                      </span>
                    </div>
                  </div>
                  <div className="p-4 md:p-5">
                    <h3 className="text-base md:text-lg font-bold text-foreground-900 mb-2 font-heading group-hover:text-primary-600 transition-colors line-clamp-2">
                      {article.title}
                    </h3>
                    <p className="text-foreground-500 text-sm leading-relaxed mb-3 line-clamp-2">
                      {article.excerpt}
                    </p>
                    <div className="flex items-center gap-3 text-foreground-400 text-xs">
                      <span className="flex items-center gap-1">
                        <i className="ri-calendar-line"></i>
                        {article.date}
                      </span>
                      <span className="flex items-center gap-1">
                        <i className="ri-time-line"></i>
                        {article.readTime}
                      </span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}